import {
  addNavMenuItem,
  DataService,
  ModalService,
  NotificationService,
  registerBulkAction,
} from "@bb-vendure/admin-ui/core";
import { forkJoin, from } from 'rxjs';
import { DeleteStaticDocument, DeleteStaticPageClassificationDocument } from "src/generated-gql/graphql";
export default [
  addNavMenuItem(
    {
      id: "static",
      label: "nav.static-page",
      routerLink: ["/extensions/static"],
      icon: "star",
    },
    "marketing"
  ),
  addNavMenuItem(
    {
      id: "static-classes",
      label: "nav.static-page-classifications",
      routerLink: ["/extensions/static-class"],
      icon: "page",
    },
    "marketing"
  ),

  registerBulkAction({
    location: "static-page-classcification-list",
    label: "Delete",
    icon: "remove",
    onClick: ({ injector, selection, clearSelection, hostComponent }) => {
      const modalService = injector.get(ModalService);
      const notiService = injector.get(NotificationService);
      const dataService = injector.get(DataService);
      modalService
        .dialog({
          title: `Remove selected data?`,
          buttons: [
            { type: "secondary", label: "cancel" },
            { type: "primary", label: "Remove", returnValue: true },
          ],
        })
        .subscribe(async (response) => {
          if (response) {
            const deleteObservables = selection.map((item) =>
              from(dataService.mutate(DeleteStaticPageClassificationDocument, { id: item.id }))
            );
    
            // Use forkJoin to wait for all observables to complete
            forkJoin(deleteObservables).subscribe(
              async (results) => {
                await notiService.success(`${selection.length} Items deleted`);
                clearSelection();
                await hostComponent.refresh();
              },
              async (error) => {
                await notiService.error(`${selection.length} deletion failed!`);
              }
            );

          }
        });
    },
  }),

  registerBulkAction({
    location: "static-list",
    label: "Delete",
    icon: "remove",
    onClick: ({ injector, selection, clearSelection, hostComponent }) => {
      const modalService = injector.get(ModalService);
      const notiService = injector.get(NotificationService);
      const dataService = injector.get(DataService);
      modalService
        .dialog({
          title: `Remove selected data?`,
          buttons: [
            { type: "secondary", label: "cancel" },
            { type: "primary", label: "Remove", returnValue: true },
          ],
        })
        .subscribe(async (response) => {
          if (response) {
            const deleteObservables = selection.map((item) =>
              from(dataService.mutate(DeleteStaticDocument, { id: item.id }))
            );
    
            forkJoin(deleteObservables).subscribe(
              async (results) => {
                await notiService.success(`${selection.length} Items deleted`);
                clearSelection();
                await hostComponent.refresh();
              },
              async (error) => {
                await notiService.error(`${selection.length} deletion failed!`);
              }
            );

          }
        });
    },
  }),
];
